export enum StringKey {
  // FAQsSection
  FAQ_LABEL = 'FAQ_LABEL',
  FREQUENTLY_ASKED_QUESTIONS = 'FREQUENTLY_ASKED_QUESTIONS',
  FAQS_SUBTITLE = 'FAQS_SUBTITLE',
  FAQ_1_TITLE = 'FAQ_1_TITLE',
  FAQ_1_DESC = 'FAQ_1_DESC',
  FAQ_2_TITLE = 'FAQ_2_TITLE',
  FAQ_2_DESC = 'FAQ_2_DESC',
  FAQ_3_TITLE = 'FAQ_3_TITLE',
  FAQ_3_DESC = 'FAQ_3_DESC',
  FAQ_4_TITLE = 'FAQ_4_TITLE',
  FAQ_4_DESC = 'FAQ_4_DESC',
  FAQ_5_TITLE = 'FAQ_5_TITLE',
  FAQ_5_DESC = 'FAQ_5_DESC',
  FAQ_6_TITLE = 'FAQ_6_TITLE',
  FAQ_6_DESC = 'FAQ_6_DESC',

  // FeaturesExtraSection
  ORGANIZER = 'ORGANIZER',
  ORGANIZER_DESC = 'ORGANIZER_DESC',
  BOOK_A_DEMO = 'BOOK_A_DEMO',
  JOIN_WAITLIST = 'JOIN_WAITLIST',
  VENDOR_SPONSOR_EXHIBITOR_SPEAKER = 'VENDOR_SPONSOR_EXHIBITOR_SPEAKER',
  VENDOR_SPONSOR_DESC = 'VENDOR_SPONSOR_DESC',
  ATTENDEE = 'ATTENDEE',
  ATTENDEE_DESC = 'ATTENDEE_DESC',
  ATTENDEE_DESC_2 = 'ATTENDEE_DESC_2',
  FEATURES_SECTION_EXTRA_LABEL_1 = 'FEATURES_SECTION_EXTRA_LABEL_1',
  FEATURES_SECTION_EXTRA_TITLE_1 = 'FEATURES_SECTION_EXTRA_TITLE_1',
  FEATURES_SECTION_EXTRA_DESC_1 = 'FEATURES_SECTION_EXTRA_DESC_1',
  ORGANIZE_WITH_CONFIDENCE = 'ORGANIZE_WITH_CONFIDENCE',
  WIN_MORE_TENDERS = 'WIN_MORE_TENDERS',
  BRANDED_TICKETS = 'BRANDED_TICKETS',
  SPONSORS_IMPACT = 'SPONSORS_IMPACT',
  FEATURES_SECTION_EXTRA_LABEL_2 = 'FEATURES_SECTION_EXTRA_LABEL_2',
  FEATURES_SECTION_EXTRA_TITLE_2 = 'FEATURES_SECTION_EXTRA_TITLE_2',
  FEATURES_SECTION_EXTRA_DESC_2 = 'FEATURES_SECTION_EXTRA_DESC_2',

  // FeaturesSection
  EVENTS = 'EVENTS',
  BUDGET = 'BUDGET',
  SOCIAL = 'SOCIAL',
  TENDERS = 'TENDERS',
  INVITATIONS = 'INVITATIONS',
  TICKETS = 'TICKETS',
  TEAMS = 'TEAMS',
  CALENDAR = 'CALENDAR',
  FEATURES_SECTION_LABEL_1 = 'FEATURES_SECTION_LABEL_1',
  FEATURES_SECTION_TITLE_1 = 'FEATURES_SECTION_TITLE_1',
  FEATURES_SECTION_DESC_1 = 'FEATURES_SECTION_DESC_1',
  LARGE_CARD_TEXT_1 = 'LARGE_CARD_TEXT_1',
  LARGE_CARD_TEXT_2 = 'LARGE_CARD_TEXT_2',
  LARGE_CARD_TEXT_3 = 'LARGE_CARD_TEXT_3',
  LARGE_CARD_TEXT_4 = 'LARGE_CARD_TEXT_4',
  LARGE_CARD_TEXT_5 = 'LARGE_CARD_TEXT_5',
  LARGE_CARD_TEXT_6 = 'LARGE_CARD_TEXT_6',
  FEATURES_SECTION_LABEL_2 = 'FEATURES_SECTION_LABEL_2',
  FEATURES_SECTION_TITLE_2 = 'FEATURES_SECTION_TITLE_2',
  FEATURES_SECTION_DESC_2 = 'FEATURES_SECTION_DESC_2',

  // ProductSection
  THE_PLACE_IS_YOURS = 'THE_PLACE_IS_YOURS',
  ALL_IN_ONE_HUB = 'ALL_IN_ONE_HUB',
  MAAZEEB_PLATFORM_DESC = 'MAAZEEB_PLATFORM_DESC',
  LEARN_MORE = 'LEARN_MORE',
  REGISTER_NOW = 'REGISTER_NOW',

  // PricingSection
  PRICING_SECTION = 'PRICING_SECTION',

  // ContactUsSection
  CONTACT_US_SECTION = 'CONTACT_US_SECTION',
  CONTACT_US_LABEL = 'CONTACT_US_LABEL',
  CONTACT_US_HEADING = 'CONTACT_US_HEADING',
  CONTACT_US_SUBTITLE = 'CONTACT_US_SUBTITLE',
  FIRST_NAME = 'FIRST_NAME',
  ENTER_FIRST_NAME = 'ENTER_FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  ENTER_LAST_NAME = 'ENTER_LAST_NAME',
  EMAIL = 'EMAIL',
  ENTER_EMAIL = 'ENTER_EMAIL',
  INQUIRY_TYPE = 'INQUIRY_TYPE',
  SELECT_INQUIRY_TYPE = 'SELECT_INQUIRY_TYPE',
  HEARD_FROM = 'HEARD_FROM',
  SELECT = 'SELECT',
  MESSAGE = 'MESSAGE',
  WRITE_YOUR_MESSAGE = 'WRITE_YOUR_MESSAGE',
  AGREE_TERMS_POLICY = 'AGREE_TERMS_POLICY',
  TERMS_OF_USE = 'TERMS_OF_USE',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  SUBMIT_FORM = 'SUBMIT_FORM',
  AND = 'AND',

  // Validation messages
  FIRST_NAME_REQUIRED = 'FIRST_NAME_REQUIRED',
  LAST_NAME_REQUIRED = 'LAST_NAME_REQUIRED',
  EMAIL_REQUIRED = 'EMAIL_REQUIRED',
  EMAIL_INVALID = 'EMAIL_INVALID',
  INQUIRY_TYPE_REQUIRED = 'INQUIRY_TYPE_REQUIRED',
  HEARD_FROM_REQUIRED = 'HEARD_FROM_REQUIRED',
  MESSAGE_REQUIRED = 'MESSAGE_REQUIRED',
  AGREE_TERMS_REQUIRED = 'AGREE_TERMS_REQUIRED',

  // Footer
  FOOTER_COPYRIGHT = 'FOOTER_COPYRIGHT',

  // Header/Nav
  NAV_PRODUCT = 'NAV_PRODUCT',
  NAV_FEATURES = 'NAV_FEATURES',
  NAV_PRICING = 'NAV_PRICING',
  NAV_FAQS = 'NAV_FAQS',
  NAV_CONTACT_US = 'NAV_CONTACT_US',
  REQUEST_A_DEMO = 'REQUEST_A_DEMO',

  // RequestDemoSection
  REQUEST_SUCCESS_TITLE = 'REQUEST_SUCCESS_TITLE',
  REQUEST_SUCCESS_DESC = 'REQUEST_SUCCESS_DESC',
  GOT_IT = 'GOT_IT',
  MAAZEEB_IN_ACTION = 'MAAZEEB_IN_ACTION',
  PERSONALIZED_DEMO_TITLE = 'PERSONALIZED_DEMO_TITLE',
  DEMO_TOOLS_DESC = 'DEMO_TOOLS_DESC',
  SEE_DIFFERENCE = 'SEE_DIFFERENCE',
  PHONE_NUMBER = 'PHONE_NUMBER',
  ENTER_PHONE_NUMBER = 'ENTER_PHONE_NUMBER',
  ORGANIZATION_NAME = 'ORGANIZATION_NAME',
  ENTER_ORGANIZATION_NAME = 'ENTER_ORGANIZATION_NAME',
  SECTOR_TYPE = 'SECTOR_TYPE',
  SELECT_YOUR_SECTOR = 'SELECT_YOUR_SECTOR',
  COUNTRY = 'COUNTRY',
  SELECT_COUNTRY = 'SELECT_COUNTRY',

  // Validation messages (RequestDemoSection)
  PHONE_NUMBER_REQUIRED = 'PHONE_NUMBER_REQUIRED',
  ORGANIZATION_NAME_REQUIRED = 'ORGANIZATION_NAME_REQUIRED',
  SECTOR_TYPE_REQUIRED = 'SECTOR_TYPE_REQUIRED',
  COUNTRY_REQUIRED = 'COUNTRY_REQUIRED',
  VENDOR = 'VENDOR',
  SPONSOR = 'SPONSOR',

  JOIN_WAITLIST_TITLE = 'JOIN_WAITLIST_TITLE',
  JOIN_WAITLIST_DESC = 'JOIN_WAITLIST_DESC',
  YOUR_EMAIL = 'YOUR_EMAIL',
  BEST_SUITED = 'BEST_SUITED',
  ORGANIZERS = 'ORGANIZERS',
  VENDORS = 'VENDORS',
  SPONSORS = 'SPONSORS',
  EXHIBITORS = 'EXHIBITORS',
  SPEAKERS = 'SPEAKERS',
  ATTENDEES = 'ATTENDEES',
  WAITLIST_MODAL_TITLE = 'WAITLIST_MODAL_TITLE',
  WAITLIST_MODAL_DESC = 'WAITLIST_MODAL_DESC',

  SECTOR_TECHNOLOGY = 'SECTOR_TECHNOLOGY',
  SECTOR_FINANCE_AND_INVESTMENT = 'SECTOR_FINANCE_AND_INVESTMENT',
  SECTOR_ENVIRONMENTAL = 'SECTOR_ENVIRONMENTAL',
  SECTOR_SOCIAL_AND_CHARITY_IMPACT = 'SECTOR_SOCIAL_AND_CHARITY_IMPACT',
  SECTOR_GOVERNMENT = 'SECTOR_GOVERNMENT',
  SECTOR_SCIENCE_AND_EDUCATION = 'SECTOR_SCIENCE_AND_EDUCATION',
  SECTOR_TRAVEL_AND_TOURISM = 'SECTOR_TRAVEL_AND_TOURISM',
  SECTOR_MEDIA_AND_COMMUNICATIONS = 'SECTOR_MEDIA_AND_COMMUNICATIONS',
  SECTOR_CORPORATE_AND_HUMAN_RESOURCES = 'SECTOR_CORPORATE_AND_HUMAN_RESOURCES',
  SECTOR_HEALTH_AND_WELLNESS = 'SECTOR_HEALTH_AND_WELLNESS',
  SECTOR_SPORTS_AND_RECREATION = 'SECTOR_SPORTS_AND_RECREATION',
  SECTOR_ART_AND_CULTURE = 'SECTOR_ART_AND_CULTURE',
  SECTOR_ENTERTAINMENT_AND_EVENT_MANAGEMENT = 'SECTOR_ENTERTAINMENT_AND_EVENT_MANAGEMENT',
  SECTOR_OTHER = 'SECTOR_OTHER',

  INQUIRY_GENERAL = 'INQUIRY_GENERAL',
  INQUIRY_DEMO_REQUEST = 'INQUIRY_DEMO_REQUEST',
  INQUIRY_TECHNICAL_SUPPORT = 'INQUIRY_TECHNICAL_SUPPORT',
  INQUIRY_SUBSCRIPTION_AND_PRICING = 'INQUIRY_SUBSCRIPTION_AND_PRICING',
  INQUIRY_PARTNERSHIP_OPPORTUNITIES = 'INQUIRY_PARTNERSHIP_OPPORTUNITIES',
  INQUIRY_SPONSORSHIP_DEALS = 'INQUIRY_SPONSORSHIP_DEALS',
  INQUIRY_VENDOR_REGISTRATION = 'INQUIRY_VENDOR_REGISTRATION',
  INQUIRY_MEDIA_AND_PR = 'INQUIRY_MEDIA_AND_PR',
  INQUIRY_EVENT_MANAGEMENT_SERVICES = 'INQUIRY_EVENT_MANAGEMENT_SERVICES',
  INQUIRY_FEEDBACK_OR_SUGGESTIONS = 'INQUIRY_FEEDBACK_O_SUGGESTIONS',
  INQUIRY_INVESTOR_RELATIONS = 'INQUIRY_INVESTOR_RELATIONS',
  INQUIRY_OTHER = 'INQUIRY_OTHER',

  HEARD_FROM_GEA = 'HEARD_FROM_GEA',
  HEARD_FROM_INCUBATORS_AND_ACCELERATORS = 'HEARD_FROM_INCUBATORS_AND_ACCELERATORS',
  HEARD_FROM_PLUG_AND_PLAY = 'HEARD_FROM_PLUG_AND_PLAY',
  HEARD_FROM_SOCIAL_MEDIA = 'HEARD_FROM_SOCIAL_MEDIA',
  HEARD_FROM_FRIEND_OR_COLLEAGUE = 'HEARD_FROM_FRIEND_OR_COLLEAGUE',
  HEARD_FROM_EVENT_OR_EXHIBITION = 'HEARD_FROM_EVENT_OR_EXHIBITION',
  HEARD_FROM_ONLINE_SEARCH = 'HEARD_FROM_ONLINE_SEARCH',
  HEARD_FROM_OTHER = 'HEARD_FROM_OTHER',

  TOAST_ERROR_TITLE = 'TOAST_ERROR_TITLE',
  TOAST_ERROR_DESC = 'TOAST_ERROR_DESC',
  MESSAGE_SENT = 'MESSAGE_SENT',
  MESSAGE_SENT_DESC = 'MESSAGE_SENT_DESC',

  YOU_ARE_ALL_SET_MSG = 'YOU_ARE_ALL_SET_MSG',
  TOO_MANY_REQUESTS_MSG = 'TOO_MANY_REQUESTS_MSG',
  BACK = 'BACK',

  //Terms of Use and Privacy policy
  TERMS_TITLE = 'TERMS_TITLE',
  TERMS_LAST_UPDATED = 'TERMS_LAST_UPDATED',
  TERMS_ACCEPTANCE_TITLE = 'TERMS_ACCEPTANCE_TITLE',
  TERMS_ACCEPTANCE_P1 = 'TERMS_ACCEPTANCE_P1',
  TERMS_ACCEPTANCE_P2 = 'TERMS_ACCEPTANCE_P2',
  TERMS_ACCEPTANCE_P3 = 'TERMS_ACCEPTANCE_P3',
  TERMS_DEFINITIONS_TITLE = 'TERMS_DEFINITIONS_TITLE',
  TERMS_DEFINITIONS_SYSTEM = 'TERMS_DEFINITIONS_SYSTEM',
  TERMS_DEFINITIONS_USER = 'TERMS_DEFINITIONS_USER',
  TERMS_DEFINITIONS_ORGANIZER = 'TERMS_DEFINITIONS_ORGANIZER',
  TERMS_DEFINITIONS_SPONSOR = 'TERMS_DEFINITIONS_SPONSOR',
  TERMS_DEFINITIONS_EXHIBITOR = 'TERMS_DEFINITIONS_EXHIBITOR',
  TERMS_DEFINITIONS_VENDOR = 'TERMS_DEFINITIONS_VENDOR',
  TERMS_DEFINITIONS_SPEAKER = 'TERMS_DEFINITIONS_SPEAKER',
  TERMS_DEFINITIONS_ATTENDEE_VISITOR = 'TERMS_DEFINITIONS_ATTENDEE_VISITOR',
  TERMS_REGISTRATION_TITLE = 'TERMS_REGISTRATION_TITLE',
  TERMS_REGISTRATION_REQUIREMENTS = 'TERMS_REGISTRATION_REQUIREMENTS',
  TERMS_USER_ELIGIBILITY = 'TERMS_USER_ELIGIBILITY',
  TERMS_ELECTRONIC_COMMUNICATIONS = 'TERMS_ELECTRONIC_COMMUNICATIONS',
  TERMS_DATA_UPDATES = 'TERMS_DATA_UPDATES',
  TERMS_SUBSCRIPTIONS_TITLE = 'TERMS_SUBSCRIPTIONS_TITLE',
  TERMS_ORGANIZER_SUBSCRIPTION = 'TERMS_ORGANIZER_SUBSCRIPTION',
  TERMS_TRANSACTION_COMMISSIONS = 'TERMS_TRANSACTION_COMMISSIONS',
  TERMS_VENDOR_SPONSOR_FEES = 'TERMS_VENDOR_SPONSOR_FEES',
  TERMS_PAYMENT_METHODS = 'TERMS_PAYMENT_METHODS',
  TERMS_TENDERING_TITLE = 'TERMS_TENDERING_TITLE',
  TERMS_TENDERING_P1 = 'TERMS_TENDERING_P1',
  TERMS_TENDERING_P2 = 'TERMS_TENDERING_P2',
  TERMS_TENDERING_P3 = 'TERMS_TENDERING_P3',
  TERMS_PAYMENTS_TITLE = 'TERMS_PAYMENTS_TITLE',
  TERMS_PAYMENTS_P1 = 'TERMS_PAYMENTS_P1',
  TERMS_PAYMENTS_P2 = 'TERMS_PAYMENTS_P2',
  TERMS_PAYMENTS_P3 = 'TERMS_PAYMENTS_P3',
  TERMS_PAYMENTS_P4 = 'TERMS_PAYMENTS_P4',
  TERMS_INTELLECTUAL_PROPERTY_TITLE = 'TERMS_INTELLECTUAL_PROPERTY_TITLE',
  TERMS_INTELLECTUAL_PROPERTY_P1 = 'TERMS_INTELLECTUAL_PROPERTY_P1',
  TERMS_INTELLECTUAL_PROPERTY_P2 = 'TERMS_INTELLECTUAL_PROPERTY_P2',
  TERMS_INTELLECTUAL_PROPERTY_P3 = 'TERMS_INTELLECTUAL_PROPERTY_P3',
  TERMS_PROHIBITED_ACTIVITIES_TITLE = 'TERMS_PROHIBITED_ACTIVITIES_TITLE',
  TERMS_PROHIBITED_ACTIVITIES_P1 = 'TERMS_PROHIBITED_ACTIVITIES_P1',
  TERMS_PROHIBITED_ACTIVITIES_BULLET1 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET1',
  TERMS_PROHIBITED_ACTIVITIES_BULLET2 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET2',
  TERMS_PROHIBITED_ACTIVITIES_BULLET3 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET3',
  TERMS_PROHIBITED_ACTIVITIES_BULLET4 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET4',
  TERMS_PROHIBITED_ACTIVITIES_BULLET5 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET5',
  TERMS_PROHIBITED_ACTIVITIES_BULLET6 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET6',
  TERMS_PROHIBITED_ACTIVITIES_BULLET7 = 'TERMS_PROHIBITED_ACTIVITIES_BULLET7',
  TERMS_PRIVACY_TITLE = 'TERMS_PRIVACY_TITLE',
  TERMS_PRIVACY_P1 = 'TERMS_PRIVACY_P1',
  TERMS_TERM_TERMINATION_TITLE = 'TERMS_TERM_TERMINATION_TITLE',
  TERMS_TERM_TERMINATION_P1 = 'TERMS_TERM_TERMINATION_P1',
  TERMS_TERM_TERMINATION_P2 = 'TERMS_TERM_TERMINATION_P2',
  TERMS_TERM_TERMINATION_P3 = 'TERMS_TERM_TERMINATION_P3',
  TERMS_TERM_TERMINATION_P4 = 'TERMS_TERM_TERMINATION_P4',
  TERMS_TERM_TERMINATION_P5 = 'TERMS_TERM_TERMINATION_P5',
  TERMS_TERM_TERMINATION_P6 = 'TERMS_TERM_TERMINATION_P6',
  TERMS_CHANGES_INTERRUPTS_TITLE = 'TERMS_CHANGES_INTERRUPTS_TITLE',
  TERMS_CHANGES_INTERRUPTS_P1 = 'TERMS_CHANGES_INTERRUPTS_P1',
  TERMS_CHANGES_INTERRUPTS_P2 = 'TERMS_CHANGES_INTERRUPTS_P2',
  TERMS_DISCLAIMER_TITLE = 'TERMS_DISCLAIMER_TITLE',
  TERMS_DISCLAIMER_P1 = 'TERMS_DISCLAIMER_P1',
  TERMS_DISCLAIMER_P2 = 'TERMS_DISCLAIMER_P2',
  TERMS_DISCLAIMER_P3 = 'TERMS_DISCLAIMER_P3',
  TERMS_INDEMNIFICATION_TITLE = 'TERMS_INDEMNIFICATION_TITLE',
  TERMS_INDEMNIFICATION_P1 = 'TERMS_INDEMNIFICATION_P1',
  TERMS_GOVERNING_LAW_TITLE = 'TERMS_GOVERNING_LAW_TITLE',
  TERMS_GOVERNING_LAW_P1 = 'TERMS_GOVERNING_LAW_P1',
  TERMS_GENERAL_PROVISIONS_TITLE = 'TERMS_GENERAL_PROVISIONS_TITLE',
  TERMS_GENERAL_PROVISIONS_P1 = 'TERMS_GENERAL_PROVISIONS_P1',
  TERMS_GENERAL_PROVISIONS_P2 = 'TERMS_GENERAL_PROVISIONS_P2',
  TERMS_GENERAL_PROVISIONS_P3 = 'TERMS_GENERAL_PROVISIONS_P3',
  TERMS_GENERAL_PROVISIONS_P4 = 'TERMS_GENERAL_PROVISIONS_P4',
  TERMS_GENERAL_PROVISIONS_P5 = 'TERMS_GENERAL_PROVISIONS_P5',
  TERMS_LANGUAGE_TITLE = 'TERMS_LANGUAGE_TITLE',
  TERMS_LANGUAGE_P1 = 'TERMS_LANGUAGE_P1',
  PRIVACY_TITLE = 'PRIVACY_TITLE',
  PRIVACY_WHO_WE_ARE_TITLE = 'PRIVACY_WHO_WE_ARE_TITLE',
  PRIVACY_DATA_CONTROLLER = 'PRIVACY_DATA_CONTROLLER',
  PRIVACY_POLICY_APPLIES = 'PRIVACY_POLICY_APPLIES',
  PRIVACY_LEGAL_BASES_TITLE = 'PRIVACY_LEGAL_BASES_TITLE',
  PRIVACY_LEGAL_BASES_P1 = 'PRIVACY_LEGAL_BASES_P1',
  PRIVACY_LEGAL_BASES_A = 'PRIVACY_LEGAL_BASES_A',
  PRIVACY_LEGAL_BASES_B = 'PRIVACY_LEGAL_BASES_B',
  PRIVACY_LEGAL_BASES_C = 'PRIVACY_LEGAL_BASES_C',
  PRIVACY_LEGAL_BASES_D = 'PRIVACY_LEGAL_BASES_D',
  PRIVACY_DATA_WE_COLLECT_TITLE = 'PRIVACY_DATA_WE_COLLECT_TITLE',
  PRIVACY_DATA_WE_COLLECT_P1 = 'PRIVACY_DATA_WE_COLLECT_P1',
  PRIVACY_DATA_IDENTITY_CONTACT = 'PRIVACY_DATA_IDENTITY_CONTACT',
  PRIVACY_DATA_BUSINESS = 'PRIVACY_DATA_BUSINESS',
  PRIVACY_DATA_ACCOUNT_USAGE = 'PRIVACY_DATA_ACCOUNT_USAGE',
  PRIVACY_DATA_MARKETING = 'PRIVACY_DATA_MARKETING',
  PRIVACY_DATA_PAYMENT = 'PRIVACY_DATA_PAYMENT',
  PRIVACY_DATA_CONTRACTING = 'PRIVACY_DATA_CONTRACTING',
  PRIVACY_HOW_WE_COLLECT_TITLE = 'PRIVACY_HOW_WE_COLLECT_TITLE',
  PRIVACY_HOW_WE_COLLECT_P1 = 'PRIVACY_HOW_WE_COLLECT_P1',
  PRIVACY_HOW_DIRECT_INTERACTIONS = 'PRIVACY_HOW_DIRECT_INTERACTIONS',
  PRIVACY_HOW_AUTOMATED = 'PRIVACY_HOW_AUTOMATED',
  PRIVACY_HOW_THIRD_PARTIES = 'PRIVACY_HOW_THIRD_PARTIES',
  PRIVACY_PURPOSES_TITLE = 'PRIVACY_PURPOSES_TITLE',
  PRIVACY_PURPOSES_P1 = 'PRIVACY_PURPOSES_P1',
  PRIVACY_PURPOSE_OPERATING_ACCOUNTS = 'PRIVACY_PURPOSE_OPERATING_ACCOUNTS',
  PRIVACY_PURPOSE_MANAGING_OFFERS = 'PRIVACY_PURPOSE_MANAGING_OFFERS',
  PRIVACY_PURPOSE_PROCESSING_PAYMENTS = 'PRIVACY_PURPOSE_PROCESSING_PAYMENTS',
  PRIVACY_PURPOSE_CUSTOMER_SUPPORT = 'PRIVACY_PURPOSE_CUSTOMER_SUPPORT',
  PRIVACY_PURPOSE_IMPROVING_SYSTEM = 'PRIVACY_PURPOSE_IMPROVING_SYSTEM',
  PRIVACY_PURPOSE_SECURITY = 'PRIVACY_PURPOSE_SECURITY',
  PRIVACY_PURPOSE_MARKETING = 'PRIVACY_PURPOSE_MARKETING',
  PRIVACY_PURPOSE_COMPLIANCE = 'PRIVACY_PURPOSE_COMPLIANCE',
  PRIVACY_MARKETING_MESSAGES_TITLE = 'PRIVACY_MARKETING_MESSAGES_TITLE',
  PRIVACY_MARKETING_MESSAGES_P1 = 'PRIVACY_MARKETING_MESSAGES_P1',
  PRIVACY_MARKETING_MESSAGES_P2 = 'PRIVACY_MARKETING_MESSAGES_P2',
  PRIVACY_MARKETING_MESSAGES_P3 = 'PRIVACY_MARKETING_MESSAGES_P3',
  PRIVACY_COOKIES_TITLE = 'PRIVACY_COOKIES_TITLE',
  PRIVACY_COOKIES_P1 = 'PRIVACY_COOKIES_P1',
  PRIVACY_COOKIES_P2 = 'PRIVACY_COOKIES_P2',
  PRIVACY_DATA_SHARING_TITLE = 'PRIVACY_DATA_SHARING_TITLE',
  PRIVACY_DATA_SHARING_P1 = 'PRIVACY_DATA_SHARING_P1',
  PRIVACY_DATA_SHARING_PAYMENT_PROCESSORS = 'PRIVACY_DATA_SHARING_PAYMENT_PROCESSORS',
  PRIVACY_DATA_SHARING_CONTRACTING_PARTIES = 'PRIVACY_DATA_SHARING_CONTRACTING_PARTIES',
  PRIVACY_DATA_SHARING_AUTHORITIES = 'PRIVACY_DATA_SHARING_AUTHORITIES',
  PRIVACY_DATA_SHARING_P2 = 'PRIVACY_DATA_SHARING_P2',
  PRIVACY_CROSS_BORDER_TITLE = 'PRIVACY_CROSS_BORDER_TITLE',
  PRIVACY_CROSS_BORDER_P1 = 'PRIVACY_CROSS_BORDER_P1',
  PRIVACY_CROSS_BORDER_BULLET1 = 'PRIVACY_CROSS_BORDER_BULLET1',
  PRIVACY_CROSS_BORDER_BULLET2 = 'PRIVACY_CROSS_BORDER_BULLET2',
  PRIVACY_CROSS_BORDER_BULLET3 = 'PRIVACY_CROSS_BORDER_BULLET3',
  PRIVACY_INFORMATION_SECURITY_TITLE = 'PRIVACY_INFORMATION_SECURITY_TITLE',
  PRIVACY_INFORMATION_SECURITY_P1 = 'PRIVACY_INFORMATION_SECURITY_P1',
  PRIVACY_INFORMATION_SECURITY_P2 = 'PRIVACY_INFORMATION_SECURITY_P2',
  PRIVACY_INFORMATION_SECURITY_ACCESS_CONTROLS = 'PRIVACY_INFORMATION_SECURITY_ACCESS_CONTROLS',
  PRIVACY_INFORMATION_SECURITY_ENCRYPTION = 'PRIVACY_INFORMATION_SECURITY_ENCRYPTION',
  PRIVACY_INFORMATION_SECURITY_LOGGING = 'PRIVACY_INFORMATION_SECURITY_LOGGING',
  PRIVACY_RETENTION_TITLE = 'PRIVACY_RETENTION_TITLE',
  PRIVACY_RETENTION_P1 = 'PRIVACY_RETENTION_P1',
  PRIVACY_RETENTION_P2 = 'PRIVACY_RETENTION_P2',
  PRIVACY_YOUR_RIGHTS_TITLE = 'PRIVACY_YOUR_RIGHTS_TITLE',
  PRIVACY_YOUR_RIGHTS_P1 = 'PRIVACY_YOUR_RIGHTS_P1',
  PRIVACY_YOUR_RIGHTS_ACCESS = 'PRIVACY_YOUR_RIGHTS_ACCESS',
  PRIVACY_YOUR_RIGHTS_RECTIFY = 'PRIVACY_YOUR_RIGHTS_RECTIFY',
  PRIVACY_YOUR_RIGHTS_RESTRICT = 'PRIVACY_YOUR_RIGHTS_RESTRICT',
  PRIVACY_YOUR_RIGHTS_OBJECT_MARKETING = 'PRIVACY_YOUR_RIGHTS_OBJECT_MARKETING',
  PRIVACY_YOUR_RIGHTS_DESTRUCTION = 'PRIVACY_YOUR_RIGHTS_DESTRUCTION',
  PRIVACY_YOUR_RIGHTS_WITHDRAW_CONSENT = 'PRIVACY_YOUR_RIGHTS_WITHDRAW_CONSENT',
  PRIVACY_YOUR_RIGHTS_P2 = 'PRIVACY_YOUR_RIGHTS_P2',
  PRIVACY_BREACH_NOTIFICATION_TITLE = 'PRIVACY_BREACH_NOTIFICATION_TITLE',
  PRIVACY_BREACH_NOTIFICATION_P1 = 'PRIVACY_BREACH_NOTIFICATION_P1',
  PRIVACY_BREACH_NOTIFICATION_AUTHORITY = 'PRIVACY_BREACH_NOTIFICATION_AUTHORITY',
  PRIVACY_BREACH_NOTIFICATION_INDIVIDUALS = 'PRIVACY_BREACH_NOTIFICATION_INDIVIDUALS',
  PRIVACY_BREACH_NOTIFICATION_DETAILS = 'PRIVACY_BREACH_NOTIFICATION_DETAILS',
  PRIVACY_BREACH_NOTIFICATION_P2 = 'PRIVACY_BREACH_NOTIFICATION_P2',
  PRIVACY_ELECTRONIC_SIGNATURES_TITLE = 'PRIVACY_ELECTRONIC_SIGNATURES_TITLE',
  PRIVACY_ELECTRONIC_SIGNATURES_P1 = 'PRIVACY_ELECTRONIC_SIGNATURES_P1',
  PRIVACY_LANGUAGE_TITLE = 'PRIVACY_LANGUAGE_TITLE',
  PRIVACY_LANGUAGE_P1 = 'PRIVACY_LANGUAGE_P1',

  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  PAGE_NOT_FOUND_DESC = 'PAGE_NOT_FOUND_DESC',
  BACK_TO_HOME = 'BACK_TO_HOME',

  INVITATION_ACCEPT_TITLE = 'INVITATION_ACCEPT_TITLE',
  INVITATION_ACCEPT_DESC = 'INVITATION_ACCEPT_DESC',
  INVITATION_REJECT_TITLE = 'INVITATION_REJECT_TITLE',
  INVITATION_REJECT_DESC = 'INVITATION_REJECT_DESC',
  EXPLORE_EVENTS = 'EXPLORE_EVENTS',
  TICKET_DETAILS = 'TICKET_DETAILS',
  FROM = 'FROM',
  FREE = 'FREE',
  EVENT_NAME = 'EVENT_NAME',
  DATE_TIME = 'DATE_TIME',
  LOCATION = 'LOCATION',
  TICKET_TYPE_SEATING_LABEL = 'TICKET_TYPE_SEATING_LABEL',
  TICKET_TYPE_ENTRY_LABEL = 'TICKET_TYPE_ENTRY_LABEL',
  SECTION = 'SECTION',
  ROW = 'ROW',
  PLACE = 'PLACE',

  INVITATION_ERROR_TITLE = 'INVITATION_ERROR_TITLE',
  INVITATION_ERROR_DESC = 'INVITATION_ERROR_DESC',
}
